module.exports = __webpack_public_path__ + "media/images/flags/4x3/pyf-2c14ae64fb4e9f816338c43cdbb4e07f.svg";